import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { Grid } from "@material-ui/core";
import Button from "components/CustomButtons/Button.js";
import history from '../../../../../src/history';
import {
    title,
    mrAuto,
    mlAuto,
} from "assets/jss/material-kit-pro-react.js";
import mcCannLogo from '../../../../assets/img/fpmccann white.png'
import { withRouter } from "react-router-dom";
import $ from 'jquery';
import { compose } from "redux";
import { connect } from 'react-redux';

const useStyles = themse => ({
    title,
    mrAuto,
    mlAuto,

    content: {
        paddingBottom: "10px",
        paddingTop: "10px",
    },
    inlineBlock: {
        display: "inline-block",
        padding: "0px",
        width: "auto",
    },
    right: {
        margin: "0",
        float: "right!important",
        display: "block",
    },
    left: {
        margin: "0",
        float: "left!important",
        display: "block",
    },
});








class EmailConfirmDetails extends React.Component {

    componentWillReceiveProps = (newProps) => {
        try {
        }
        catch (error) {
        };
    }


    state = {
        emailAddress: '',
        foundUser: false,
        confirmedUser: [],
        data: ''
    }

    componentDidMount() {
        try {
            if (this.props.userEmail !== undefined) {
                this.setState({
                    emailAddress: this.props.userEmail
                }, () => {
                });
            }
            else {
                /*    history.push('/error-page');*/
                this.props.history.push('/error-page');
            }
        }
        catch (error) {
        };
    }


    handleLogOnClick = () => {
        window.open('TradeCustomerPortal/Login', '_blank')
    }



    // UI 
    render() {

        const { classes } = this.props;


        return (
            <div>
                <div className="email-body">
                    <div className="banner" style={{
                        background: '#125688',
                        color: 'white',
                        padding: "1em 5em",
                        overflow: "hidden"
                    }}>
                        <Grid container spacing={2}>
                            <Grid item xs={10} md={10}>
                                <h4>Activation  Successful!</h4>
                            </Grid>
                            <Grid item xs={2} md={2}>
                                <img
                                    src={mcCannLogo}
                                    height={50}
                                    width={70}
                                    alt="FPMcCannLogo"
                                />
                            </Grid>

                            <Grid item xs={12} md={12}>
                                <h1>Email Sucessfully Confirmed
                                </h1>
                            </Grid>

                        
                        </Grid>

                    </div>

                    <div className="email-content" style={{
                        padding: "1em 5em",
                        overflow: "hidden"
                    }}                >
                        <p><b> Hi {this.state.emailAddress ? this.state.emailAddress : ''}</b></p>
                        <p>Thank you for confirming your email adress. We're excited to share the latest news and updates about our product with you. If you'd like to learn more, follow us on social media!</p>
                        <br />

                        <GridContainer>

                            <GridItem xs={12} sm={12} md={12}>
                                <div className={classes.left}>
                                    <Button
                                        style={{
                                            borderRadius: 4,
                                            padding: "12px 16px",
                                            fontSize: "16px",
                                            backgroundColor: "#125688"
                                        }}

                                        size="lg"
                                        target="_blank"
                                        onClick={this.handleLogOnClick}
                                    >
                                        <i className="far fa-arrow-alt-circle-right fa-4x"></i>
                                        &nbsp;   Log On    &nbsp;
                                    </Button>
                                </div>



                                <div className={classes.right}>
                                    <p><b>Follow Our Social Media Platforms!</b></p>
                                    <a href="https://www.youtube.com/watch?v=8oTMGPAqZYk" target="_blank" rel="noopener noreferrer">
                                        <Button justIcon simple color="youtube">
                                            <i className="fab fa-youtube" />
                                        </Button>
                                    </a>

                                    <a href="https://twitter.com/FPMcCann/" target="_blank" rel="noopener noreferrer">
                                        <Button justIcon simple color="twitter">
                                            <i className="fab fa-twitter" />
                                        </Button>
                                    </a>

                                    <a href="https://www.instagram.com/fpmccann/" target="_blank" rel="noopener noreferrer">
                                        <Button justIcon simple color="instagram">
                                            <i className="fab fa-instagram" />
                                        </Button>
                                    </a>

                                    <a href="https://m.facebook.com/FP-McCann-110181082374851/" target="_blank" rel="noopener noreferrer">
                                        <Button justIcon simple color="facebook">
                                            <i className="fab fa-facebook" />
                                        </Button>
                                    </a>
                                    <a href="https://www.linkedin.com/company/fp-mccann/" target="_blank" rel="noopener noreferrer">
                                        <Button justIcon simple color="linkedin">
                                            <i className="fab fa-linkedin-in"></i>
                                        </Button>
                                    </a>
                                </div>
                            </GridItem>

                        </GridContainer>


                    </div>
                </div>
            </div>
        );
    }




};


/*export default withStyles(useStyles)(EmailConfirmDetails);*/

export default compose(withRouter, connect(null,null))(withStyles(useStyles)(EmailConfirmDetails));